// extracted by mini-css-extract-plugin
module.exports = {"container":"smvURWZywuvUxWrS9vvtYA==","content":"zGaC6zUdBH3QpDT0G7gMkw==","footer":"bTHLd1BChLVvAVkdMleLqA=="};